export const CONTRACT_PROFILE_ID = {
  TALENT: 1,
  COMPANY: 3,
}

export const getDocumentProfileId = (document) =>
  Number(document?.profile_id ?? document?.profileId)

export const filterContractDocumentsByProfile = (documents, profileId) =>
  (documents || []).filter(
    (document) => getDocumentProfileId(document) === Number(profileId)
  )

export const resolveCompanyContractId = (company, documents) => {
  const companyDocuments = filterContractDocumentsByProfile(
    documents,
    CONTRACT_PROFILE_ID.COMPANY
  )
  const companyDocIds = extractCompanyContractIds(company)

  const matched = companyDocIds
    .map((id) =>
      companyDocuments.find((document) => Number(document.id) === Number(id))
    )
    .find(Boolean)

  return matched?.id ?? companyDocuments[0]?.id ?? companyDocIds[0] ?? null
}

export const extractCompanyContractIds = (company) => {
  if (!company || typeof company !== 'object') return []

  const ids = new Set()

  const add = (value) => {
    const num = Number(value)
    if (Number.isFinite(num) && num > 0) ids.add(num)
  }

  if (Array.isArray(company.contract_ids)) {
    company.contract_ids.forEach(add)
  }
  if (Array.isArray(company.contractIds)) {
    company.contractIds.forEach(add)
  }
  add(company.contract_id)
  add(company.contractId)

  if (Array.isArray(company.contracts)) {
    company.contracts.forEach((item) => {
      add(item?.document_id)
      add(item?.contract_id)
      add(item?.contractId)
      add(item?.id)
    })
  }

  return [...ids]
}

export const normalizeSelectedContractIds = (ids) =>
  [...new Set((ids || []).map((id) => String(id)).filter(Boolean))]
